import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { object } from "prop-types";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import moment from "moment";
import { Placeholder } from "react-bootstrap";

const MasterReportITAssets = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Master Report - IT Assets"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [assetTypeOption, setAssetTypeOption] = useState([]);
  const [assetStatusOption, setAssetStatusOption] = useState([]);
  const [categoryOption, setCategoryOption] = useState([]);
  const [filterFormData, setFilterData] = useState([]);

  const columns = {
    name: { text: "Asset Name", align: "start", visible: true },
    Description: { text: "Description", align: "left", visible: true },
    Brand: { text: "Make", align: "left", visible: true },
    BatchNo: { text: "Serial #", align: "center", visible: true },
    PurchaseDate: { text: "Purchase Date", align: "center", visible: true },
    WarrantyDate: { text: "Waranty Date", align: "center", visible: true },
    Model: { text: "Model No.", align: "start", visible: true },
    InvoiceNumber: { text: "Invoice No.", align: "start", visible: true },
    AdapterNumber: { text: "Adapter No.", align: "center", visible: true },
    Allocated: { text: "Status", align: "center", visible: true },
    VendorName: { text: "Vendor", align: "start", visible: true },
    AssetPrice: { text: "Price", align: "end", visible: true },
  };
  useEffect(() => {
    fetchMasterReport();
  }, []);

  const fetchMasterReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}support-desk-reports/3?P_AssetType=${filterFormData.find((o) => o.label === "Asset Type")
          ? filterFormData.find((o) => o.label === "Asset Type").value
          : 0
        }&P_CategoryID_1160=${filterFormData.find((o) => o.label === "Category")
          ? filterFormData.find((o) => o.label === "Category").value
          : 0
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(filterFormData.find((o) => o.label === "From Date").value).format("YYYY-MM-DD")
          : ""
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(filterFormData.find((o) => o.label === "To Date").value).format("YYYY-MM-DD")
          : ""
        }&P_Allocated=${filterFormData.find((o) => o.label === "Asset Status")
          ? filterFormData.find((o) => o.label === "Asset Status").value
          : 0
        }`
      );

      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setListData(cleanedData);

        // Asset Type List
        const assetList = Object.entries(response?.data?.AssetType || {}).map(
          ([key, value]) => ({
            value: parseInt(key, 10),
            label: value,
          })
        );
        setAssetTypeOption(assetList);
        // Category List
        const categoryList = response?.data?.AssetCategory
          ? response?.data?.AssetCategory?.map((tech) => ({
            value: tech.value,
            label: tech.text,
          }))
          : [];

        setCategoryOption(categoryList);

        // Asset Status List
        const statusList = Object.entries(
          response?.data?.AllocatedType || {}
        )?.map(([key, value]) => ({
          value: parseInt(key, 10),
          label: value,
        }));
        setAssetStatusOption(statusList);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch repairable asset api. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching repairable asset api:", error);
    }
  };

  const handleGetData = () => {
    fetchMasterReport();
  };

  const formDatas = [
    {
      name: "From Date",
      type: "Date",
    },
    {
      name: "To Date",
      type: "Date",
    },
    {
      name: "Asset Type",
      type: "Select",
      placeholderText: "Select Asset Type",
      options: [...assetTypeOption],
    },
    {
      name: "Category",
      type: "Select",
      placeholderText: "Select Category",
      options: [...(categoryOption || [])],
    },
    {
      name: "Asset Status",
      type: "Select",
      options: [...(assetStatusOption || [])],
    },
  ];

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };



  const handleReset = () => {
    setFilterData([])
    fetchMasterReport()
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={listData}
              columns={columns}
              handleReset={handleReset}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isFilterRequired={true}
              isSorting={true}
              formDatas={formDatas}
              handleGetData={handleGetData}
              handleChange={handleChange}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterReportITAssets;
